/* eslint-disable max-len */
import { createContext, useContext } from 'react';
import { type ConfiguratorApplicationEntrypointContextDataFragment } from '../../../api/fragments/ConfiguratorApplicationEntrypointContextData';

export const EndpointContext = createContext<ConfiguratorApplicationEntrypointContextDataFragment>(null);

export const useEndpoint = () => {
    const context = useContext(EndpointContext);

    if (context === null) {
        throw new Error('useEndpoint must be used within an EndpointProvider');
    }

    return context;
};

export const EndpointProvider = ({
    endpoint,
    children,
}: {
    endpoint: ConfiguratorApplicationEntrypointContextDataFragment;
    children: React.ReactNode;
}) => <EndpointContext.Provider value={endpoint}>{children}</EndpointContext.Provider>;
